module.exports = newArray

function newArray (n, value) {
  n = n || 0
  var array = new Array(n)
  for (var i = 0; i < n; i++) {
    array[i] = value
  }
  return array
}



//////////////////
// WEBPACK FOOTER
// ./~/new-array/index.js
// module id = 37
// module chunks = 0